import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["setState"];
import { c as _c } from "react-compiler-runtime";
import { useCallback, useMemo, useContext } from 'react';
import { setUserAttribute } from '../api/UserSettings';
import { UserSettingsContext } from '../contexts/UserSettingsProvider';
export default function useUserSettings() {
  "use memo";

  const $ = _c(13);
  const t0 = useContext(UserSettingsContext);
  let setState;
  let state;
  if ($[0] !== t0) {
    var _t = t0;
    ({
      setState
    } = _t);
    state = _objectWithoutPropertiesLoose(_t, _excluded);
    _t;
    $[0] = t0;
    $[1] = setState;
    $[2] = state;
  } else {
    setState = $[1];
    state = $[2];
  }
  let t1;
  if ($[3] !== setState || $[4] !== state) {
    t1 = (key, value) => {
      setUserAttribute(key, JSON.stringify(value)).then(payload => {
        setState(prevState => {
          const prevSettings = prevState && prevState.settings ? prevState.settings.filter(s => s.key !== key) : [];
          return {
            loading: false,
            error: null,
            settings: [...prevSettings, payload]
          };
        });
      }).catch(error => {
        setState(Object.assign({}, state, {
          loading: false,
          error
        }));
      });
    };
    $[3] = setState;
    $[4] = state;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  const setUserSetting = t1;
  let t2;
  if ($[6] !== state.settings) {
    t2 = key_0 => {
      let setting;
      if (state.settings && state.settings.length > 0) {
        setting = state.settings.find(s_0 => s_0.key === key_0);
      }
      return setting ? setting.value : undefined;
    };
    $[6] = state.settings;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  const getUserSetting = t2;
  const t3 = !state.loading && !state.error;
  let t4;
  if ($[8] !== getUserSetting || $[9] !== setUserSetting || $[10] !== state || $[11] !== t3) {
    t4 = Object.assign({}, state, {
      hasLoaded: t3,
      setUserSetting,
      getUserSetting
    });
    $[8] = getUserSetting;
    $[9] = setUserSetting;
    $[10] = state;
    $[11] = t3;
    $[12] = t4;
  } else {
    t4 = $[12];
  }
  return t4;
}